// Generated by CoffeeScript 2.4.1
(function() {
  var WeaverModelValidator,
    indexOf = [].indexOf;

  WeaverModelValidator = class WeaverModelValidator {
    constructor(model1) {
      this.model = model1;
      this.modelNamesList = this._getModelNamesList();
    }

    _selectModel(modelName) {
      if (this.model[modelName] != null) {
        this.model[modelName];
      }
      return this.model;
    }

    _getModelNamesList() {
      var key, names, ref, value;
      names = [this.model.definition.name];
      ref = this.model.definition.includes;
      for (key in ref) {
        value = ref[key];
        names.push(value.name);
      }
      return names;
    }

    validateClassName(classNameParts) {
      var ref;
      if (classNameParts.length !== 2) {
        throw new Error(`Invalid className format: ${classNameParts.join(':')}`);
      }
      if (ref = classNameParts[0], indexOf.call(this.modelNamesList, ref) < 0) {
        throw new Error(`Invalid model name: ${classNameParts[0]}`);
      }
    }

    classExists(className) {
      var model;
      model = this._selectModel(className.split(':')[0]);
      return model.classList[className] != null;
    }

    relationExists(sourceClass, relation) {
      var model;
      model = this._selectModel(sourceClass.split(':')[0]);
      return model.classList[sourceClass].getRanges(relation).length !== 0;
    }

    relationIsValid(sourceClass, targetClass, relation) {
      var model;
      model = this._selectModel(sourceClass.split(':')[0]);
      return this.classExists(targetClass) && (indexOf.call(model.classList[sourceClass].getRanges(relation), targetClass) >= 0);
    }

    attributeExists(sourceClass, attribute) {
      var attr, i, len, model, ref;
      model = this._selectModel(sourceClass.split(':')[0]);
      ref = model.classList[sourceClass].allAttributes();
      for (i = 0, len = ref.length; i < len; i++) {
        attr = ref[i];
        if (attribute === attr.modelKey) {
          return true;
        }
      }
      return false;
    }

  };

  module.exports = WeaverModelValidator;

}).call(this);
